const scrollToTop = (): void => {
  window.scroll(0, 0)
}

export default scrollToTop
